import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import ExpenseListFilterWrapperDialog from "./FilterDialog/ExpenseListFilterWrapperDialog";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";

type Props = {
  columns: columnTypes[];
  rows: any[];
  totalExpense: any;
  onAddNew: () => void;
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const ExpenseListing = ({
  columns,
  rows,
  onAddNew,
  totalExpense,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const navigate = useNavigate();
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  return (
    <div className="flex flex-col h-full gap-2 p-4">
      {/* Page Header */}
      <div>
        <ATMPageHeader
          pageTitle="Expenses"
          searchValue={searchValue}
          onSearchChange={setSearchValue}
          hideAddButton={!isCheckActionsPermission({
            moduleName: UserModuleNameTypes.EXPENSES,
            actionName: UserModuleActionTypes.ADD,
          })}
          buttonProps={{ btnName: "Add New", onClick: () => onAddNew() }}
          isFilter={true}
          onFilterClick={() => setIsOpenFilter(true)}
        />
      </div>

      {/* Date Filter Dialog */}
      <ExpenseListFilterWrapperDialog
        open={isOpenFilter}
        onClose={() => setIsOpenFilter(false)}
      />

      <div className="pb-2 font-semibold text-md">
        Total Expenses : {totalExpense?.totalExpense}
      </div>

      {/* Table */}
      <div className="flex-1 overflow-auto flex flex-col">
        <ATMTable
          isLoading={isTableLoading}
          columns={columns}
          rows={rows}
          rowExtraClasses={() => "min-h-[40px]"}
        />
      </div>

      <div className="p-4 py-2 flex justify-end">
        <ATMPagination
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={setPage}
          onRowsPerPageChange={setRowsPerPage}
          rowCount={totalItems}
          rows={rows}
        />
      </div>
    </div>
  );
};

export default ExpenseListing;
